import { Network } from '../../../../utils/network'
import { Events } from '../../../../utils/servicesEvents'
import { Formatter } from '../../formatter'

import urls from '../urls.json'

async function createChargeback(data, onSuccessEvent, onErrorEvent) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response, Formatter)
  const onDoneEvent = parsedResponse.success ? onSuccessEvent : onErrorEvent
  Events.dispatchEvent(onDoneEvent, parsedResponse)
}

async function sendRequest(data) {
  const url = `${urls.createChargeback}`
  const body = {
    transactionData: data.payment,
    message: data.message,
  }
  const response = await Network.sendPostRequest(url, body)
  return response
}

function parseResponse(response) {
  if (
    response &&
    response.status.code === 200 &&
    response.response.statusCode == 200
  ) {
    return {
      statusCode: 200,
      success: true,
    }
  }
  if (
    response &&
    response.status.code === 404 &&
    response.response.statusCode == 404
  ) {
    return {
      success: true,
      customerNotFound: true,
    }
  }
  return Network.defaultResponseParsing(response)
}

export { createChargeback }
